function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "finals"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.77,232.66c11.26-13,55.63-79.86,70.62-127.48A75.42,75.42,0,1,0,4.26,94.67h0c.12.5.24,1,.37,1.52s.29,1.21.46,1.81C17.48,145.77,65.92,219,77.77,232.66Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "114.84 74.01 128.2 74.01 128.16 61.27 114.25 65.19 114.84 74.01"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 114.84,
  y: 75.97,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 114.84,
  y: 86.81,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 114.84,
  y: 97.45,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 114.84,
  y: 108.13,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "128.12 59.44 113.52 63.92 109.68 55.56 121.51 48.35 128.12 59.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "120.57 46.84 108.91 54.06 101.65 45.78 112.17 32.65 120.57 46.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "110.66 31.05 100.26 44.47 94.64 40.88 99.61 31.05 110.66 31.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.37 30.97 92.96 39.95 85.21 37.58 85.99 31.01 97.37 30.97"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "39.94 74.01 26.58 74.01 26.62 61.27 40.53 65.19 39.94 74.01"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 26.58,
  y: 75.97,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 26.58,
  y: 86.81,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 26.58,
  y: 97.45,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 26.58,
  y: 108.13,
  width: 13.36,
  height: 8.97
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.66 59.44 41.26 63.92 45.09 55.56 33.27 48.35 26.66 59.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "34.21 46.84 45.87 54.06 53.13 45.78 42.61 32.65 34.21 46.84"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "44.12 31.05 54.52 44.47 60.14 40.88 55.17 31.05 44.12 31.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "57.41 30.97 61.82 39.95 69.56 37.58 68.79 31.01 57.41 30.97"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M46.82,118.87V74.32A30.52,30.52,0,0,1,77.33,43.81h.06a30.52,30.52,0,0,1,30.52,30.51v44.55h4.5V74.32a35,35,0,0,0-35-35h-.06a35,35,0,0,0-35,35v44.55Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "70.2 29.43 84.62 29.43 83.42 39.91 71.33 40.05 70.2 29.43"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.78,232.14l1.89,1.64c1.48-1.72,3.43-4.22,5.78-7.42a594.7,594.7,0,0,0,33.81-53c12.63-22.18,24.87-46.78,31.53-67.91l-2.38-.75,2.34.88A77.91,77.91,0,1,0,0,77.91,78.57,78.57,0,0,0,1.83,94.69l2.45-.53,1.46-2h0L.33,88.22l1.49,6.49c.12.52.25,1,.37,1.55h0c.15.62.31,1.24.48,1.88v0c3.17,12.17,8.57,25.82,15.09,39.7a581.38,581.38,0,0,0,33,59.64c5.47,8.73,10.61,16.48,15,22.71s7.87,10.92,10.2,13.62L77.78,236l1.89-2.18-1.89-1.64,1.89-1.64c-1.4-1.61-3.43-4.22-5.88-7.58a603.91,603.91,0,0,1-35.63-56.46c-6.54-11.72-12.88-24-18.24-35.89A218.36,218.36,0,0,1,7.5,96.85v0c-.16-.57-.3-1.15-.45-1.75h0c-.12-.52-.25-1-.36-1.5l-2.43.56-1.47,2h0L8.12,100l-1.4-6.4a72.9,72.9,0,1,1,139.35,10.16l0,.06,0,.08c-7.38,23.46-22.16,52-36.48,76.19-7.16,12.1-14.21,23.13-20.15,31.92-3,4.4-5.68,8.24-8,11.37s-4.2,5.57-5.53,7.1l1.89,1.64,1.89-1.64Z"
})));

var SvgTunnel = function SvgTunnel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 155.81 235.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTunnel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tunnel.adad15d0.svg";
export { ForwardRef as ReactComponent };